import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { crowdfundingProjectTypeOptions } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'private-equity-project-type',
    templateUrl: './private-equity-project-type.component.html',
    styleUrls: ['./private-equity-project-type.component.scss'],
    standalone: false
})
export class PrivateEquityProjectTypeComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = crowdfundingProjectTypeOptions;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
